import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class SendReminderContractCommand extends BasicCommand<SendReminderContractCommand> {
    readonly virkeskopskontraktSigneringId: number;

    static readonly $type = "SendReminderContractCommand";

    static readonly $groupKey = "KontraktUtskrift";

    get primaryKey(): IPrimaryKey<SendReminderContractCommand> {
        return {
            virkeskopskontraktSigneringId: this.virkeskopskontraktSigneringId
        };
    }

    constructor(virkeskopskontraktSigneringId: number) {
        super(SendReminderContractCommand.$type, SendReminderContractCommand.$groupKey, CommandType.Replace);
        this.virkeskopskontraktSigneringId = virkeskopskontraktSigneringId;
    }
}
